<template>
  <el-card shadow="never">
    <div class="callback-toolbar">
      <el-select v-model="searchForm.callbackStatus" placeholder="回传状态" clearable class="callback-select">
        <el-option label="待回传" value="PENDING" />
        <el-option label="成功" value="SUCCESS" />
        <el-option label="失败" value="FAILED" />
        <el-option label="超时" value="EXPIRED" />
        <el-option label="忽略" value="IGNORED" />
      </el-select>
      <el-button type="primary" @click="fetchList">查询</el-button>
      <el-button @click="retrySelected" :disabled="!selectedIds.length">批量重试</el-button>
    </div>
    <el-table :data="tableData" border stripe size="small" v-loading="loading" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="45" />
      <el-table-column prop="clueId" label="线索ID" min-width="180" show-overflow-tooltip />
      <el-table-column prop="markType" label="markType" width="100" />
      <el-table-column prop="businessEvent" label="业务事件" width="140" />
      <el-table-column prop="callbackStatus" label="状态" width="100" />
      <el-table-column prop="errorInfo" label="错误信息" min-width="220" show-overflow-tooltip />
      <el-table-column prop="createdAt" label="创建时间" width="160" />
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="retrySingle(row)">重试</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-wrapper">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="total"
        :current-page.sync="page"
        :page-size="pageSize"
        @current-change="fetchList"
      />
    </div>
  </el-card>
</template>

<script>
import {
  fetchBaiduAifanfanCallbackLogs,
  retryBaiduAifanfanCallback,
  retryBaiduAifanfanCallbackBatch
} from '@/services/baiduAifanfanApi';

export default {
  name: 'BaiduCallbackLog',
  data() {
    return {
      loading: false,
      page: 1,
      pageSize: 10,
      total: 0,
      selectedIds: [],
      tableData: [],
      searchForm: {
        callbackStatus: ''
      }
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    async fetchList() {
      this.loading = true;
      try {
        const res = await fetchBaiduAifanfanCallbackLogs({
          callbackStatus: this.searchForm.callbackStatus,
          page: this.page,
          pageSize: this.pageSize
        });
        this.tableData = res.data.list || [];
        this.total = res.data.total || 0;
      } finally {
        this.loading = false;
      }
    },
    handleSelectionChange(rows) {
      this.selectedIds = rows.map((item) => item.id);
    },
    async retrySingle(row) {
      await retryBaiduAifanfanCallback(row.id);
      this.$message.success('回传执行完成');
      this.fetchList();
      this.$emit('refresh-overview');
    },
    async retrySelected() {
      await retryBaiduAifanfanCallbackBatch(this.selectedIds);
      this.$message.success('批量回传执行完成');
      this.fetchList();
      this.$emit('refresh-overview');
    }
  }
};
</script>

<style scoped>
.callback-toolbar {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}
.callback-select {
  width: 180px;
}
.pagination-wrapper {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}
</style>
